import { AdGatherersTavernPoster, AdUVPPlus } from '@/components/common/Ad'
import { ArticlePreview } from '@/components/common/ArticlePreview'
import { useAds } from '@/components/providers/AdsProvider'
import { usePage } from '@/components/providers/PageProvider'
import { getAdGatherersTavernPoster } from '@/defs/ad'
import { parseCardId } from '@/utils/cardUtil'
import { cn, isNonEmptyString } from '@/utils/commonUtil'

import styles from './FeaturedCommonArticles.module.scss'

export const FeaturedCommonArticles = () => {
  const { page } = usePage()
  const { adsDisabled, uvpPlusDisabled } = useAds()

  const articlePreviews = page?.articlePreviews?.slice(0, 2)
  const cardId = page?.featured?.rec?.cardId
  const slug = cardId ? parseCardId(cardId).slug : undefined
  const partnerCardId = page?.featured?.rec?.partnerRef?.cardId
  const slugPartner = partnerCardId ? parseCardId(partnerCardId).slug : undefined
  const slugs = [slug, slugPartner].filter(isNonEmptyString)

  const adGatherersTavernDisabled = adsDisabled || !slug || !getAdGatherersTavernPoster(slugs)

  const adSlots = Number(!adGatherersTavernDisabled) + Number(!uvpPlusDisabled)

  if (!articlePreviews?.length && adGatherersTavernDisabled && uvpPlusDisabled) return null

  return (
    <div className={cn(styles.container, { adSlots: String(adSlots), styles })}>
      <ul className={styles.list}>
        {articlePreviews?.map((article) => (
          <li className={styles.article} key={article.slug}>
            <ArticlePreview article={article} hideCategory hideExcerpt newTab showBg />
          </li>
        ))}
        {!adGatherersTavernDisabled && (
          <li className={styles.ad}>
            <AdGatherersTavernPoster slugs={slugs} />
          </li>
        )}
        {!uvpPlusDisabled && (
          <li className={styles.ad}>
            <AdUVPPlus />
          </li>
        )}
      </ul>
    </div>
  )
}
